import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "@/styles/reactnative";
import { ThemeContext } from "../../../../../../../theme/ThemeProvider";
import { CButton, CInput } from "../../../../../../components/Common";
import {
  CrossModalLeverage,
  CrossTradeAmount,
  SliderBar,
  SliderButton,
  SliderButtonContainer,
} from "./styles";
import styled from "styled-components";

const CrossSliderBar = ({ leverage, setLeverage, maxLeverage }) => {
  const { t } = useTranslation();
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const sliderBarRef = useRef<any>(null);
  const sliderButtonRef = useRef<any>(null);
  const STEP = 1;

  const { theme } = useContext(ThemeContext);

  const handleClick = (newValue) => {
    setLeverage(newValue);
  };

  const handleSliderChange = (event) => {
    const newValue = event.target.value;

    if (newValue === "") {
      setLeverage(0);
    } else {
      const parsedValue = parseFloat(newValue);
      if (!isNaN(parsedValue) && parsedValue > 0) {
        setLeverage(parsedValue);
      }
    }
  };

  const handleSliderMouseDown = (event) => {
    const newValue = parseFloat(event.target.value);
    if (newValue > 0) {
      setLeverage(newValue);
    }
  };

  const buttonIncrement = 25;
  const numButtons = Math.floor(maxLeverage / buttonIncrement);

  const buttons = Array.from({ length: numButtons }, (_, i) => {
    const leverage = (i + 1) * buttonIncrement;
    return (
      <SliderButton
        key={i.toString()}
        ref={sliderButtonRef}
        onClick={() => handleClick(leverage)}
      >
        {leverage}x
      </SliderButton>
    );
  });

  const incrementLeverage = () => {
    const max = maxLeverage;
    const val = leverage + 1;
    if (val > max) {
      setLeverage(max);
    } else {
      setLeverage(val);
    }
  };

  const decrementLeverage = () => {
    const min = 1;
    const val = leverage - 1;
    if (val < min) {
      setLeverage(1);
    } else {
      setLeverage(val);
    }
  };

  return (
    <View
      style={{
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      <CrossModalLeverage>
        <Text size={14}>{t("leverage")}</Text>
        <CrossTradeAmount >
          <CButton
            title={"-"}
            onClick={decrementLeverage}
            style={{
              color: theme.COLORS.content,
              marginBottom: 10,
              fontSize: 20,
              cursor: "pointer",
            }}
          />
          <CInput
            value={leverage}
            maxLength={4}
            onChange={handleSliderChange}
            onInputClick={(event) => {
              event.target.focus({ cursor: 0 });
            }}
            onFocus={(event) => {
              event.target.focus({ cursor: 0 });
            }}
            type={""}
            placeholder={""}
            style={{
              color: textw,
              background: "transparent",
              fontWeight: 600,
              fontSize: 16,
              border: 0,
              textAlign: "center",
              // paddingRight: '15px', // XFont가 표시될 공간을 위한 패딩
            }}
          />
          {/*<XFont theme={theme}>x</XFont>*/}
          <CButton
            title={"+"}
            onClick={incrementLeverage}
            style={{
              color: theme.COLORS.content,
              marginBottom: 10,
              fontSize: 17,
              cursor: "pointer",
            }}
          />
        </CrossTradeAmount>
      </CrossModalLeverage>

      <SliderBar
        max={maxLeverage}
        ref={sliderBarRef}
        value={leverage}
        maxLeverage={maxLeverage}
        onChange={handleSliderChange}
        onMouseUp={() => handleClick(leverage)}
        onMouseDown={handleSliderMouseDown}
        step={STEP}
      />

      <SliderButtonContainer>
        <SliderButton ref={sliderButtonRef} onClick={() => handleClick(1)}>
          1x
        </SliderButton>
        {buttons}
      </SliderButtonContainer>
    </View>
  );
};

export default CrossSliderBar;

const XFont = styled.div<{ theme: any }>`
  color: ${({ theme }) => theme.COLORS.raise};
  font-weight: 600;
  font-size: 22px;
  border: 0;
  z-index: 0;
  position: relative;
  left: -108px;
  bottom: 4.5px;
  user-select: none;
`;
